import axios from 'axios';

export const axiosInstance = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/v1`,
});

axiosInstance.interceptors.request.use(
    config => {
        // Retrieve the token from localStorage

        // Add the custom platform header
        config.headers.platform = 'web-app'; // replace 'your-platform-value' with your actual value

        return config;
    },
    error => Promise.reject(error)
);

// Response interceptor to handle 401 error
axiosInstance.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            // Remove the token and redirect to login page
            localStorage.removeItem(process.env.REACT_APP_LOCALSTORAGE_TOKEN);
            window.location.href = '/login'; // or window.location.reload();
        }
        return Promise.reject(error);
    }
);
